import React from 'react';
import "./Disclaimer.css";

const Disclaimer = () => {
    return (
        <section className="info">
            <div className="overlayed-text">
                <h1 className="meet">DISCLAIMER.</h1>
                <h1 className="meet-team">J-TEK LAW PLLC</h1>
            </div>
            <div className="container">

                <hr className="style" />
                <br />
                <div className="disclaimer-text">
                    <p>
                        The information in this web site is provided by J-TEK LAW PLLC as a courtesy to its clients and the public. Although we endeavor to keep this information current and accurate, no warranty or guarantee is made that it is correct, complete or up-to-date. These materials do not, and are not intended to, constitute legal advice.  You should not rely upon or construe the information in this web site as legal advice, and you should not act or fail to act based upon the information in this web site without seeking professional advice from a licensed practitioner.
                    </p>

                    <p>
                        The presentation of information on this website, or contact with the firm or any of its attorneys on an unsolicited basis, does not establish any form of attorney-client relationship with our firm or with Jeffrey Tekanic. An attorney-client relationship with the firm or Jeffrey Tekanic will only be established after the firm decides that it is willing and able to accept the engagement and the firm and the client enter into a written engagement letter. This website is not an offer to represent you. You should not provide any proprietary, confidential or privileged information to J-TEK LAW PLLC on an unsolicited basis, as unsolicited information will not be treated as confidential. Furthermore, sending an e-mail to J-TEK LAW PLLC also will not be considered as creating an attorney-client relationship or a request to take action with respect to the information unless an attorney-client relationship has already been established. Any request to take action, such as filing a patent application with a patent office, can only be made by an existing client of the firm.
                    </p>

                    <p>
                        This web site may contain links or may be linked to other web sites not maintained by J-TEK LAW PLLC. No representations, express or implied, are made with respect to the materials and information provided on any third-party web site linked to this web site, including any representations as to the accuracy, timeliness, reliability, suitability or completeness of any material or information on such linked site. Inclusion of a link in this web site to another web site does not imply recommendation, approval, or endorsement by J-TEK LAW PLLC of the linked site.
                    </p>

                    <p>
                        J-TEK LAW PLLC has an office only in the Commonwealth of Virginia.
                    </p>

                    <p>
                        Mr. Tekanic is licensed to practice in the District of Columbia, California and before the USPTO. Mr. Tekanic is not licensed to practice in Virginia. Mr. Tekanic’s practice in Virginia is limited to matters before the United States Patent and Trademark Office and to areas of federal law that by rule, regulation or statute do not require Virginia State Bar membership.
                    </p>

                    <p>
                        Mr. Wakeman is licensed to practice in Virginia, Ohio and before the USPTO.
                    </p>

                    <p>
                        Mr. Ussai is licensed to practice in Pennsylvania and before the USPTO.
                    </p>

                    <p>
                        Our firm does not intend to practice law in any jurisdiction where we are not licensed. All activity occurring in connection with this website, including but not limited to accessing pages and downloading materials, is presumed to occur in the Virginia.
                    </p>

                    <p>
                        Jeffrey D. Tekanic is solely responsible for the content of this website.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Disclaimer
